import { JOIN_OPERATOR } from "../../parse.utils";
import { SampleAssetTopology, SampleTopology, AssetTopology, DeviceTopology } from "../acquisition";
import { AnalysisTopology, FindingTopology } from "../analysis";
import { MethodTypeTopology } from "../protocols";
import { CaseTopology } from "../workspace";

export const SCAN_PREFIX = "scan-";

export const CASE_FIELD = [
  SampleAssetTopology.SAMPLE,
  SampleTopology.CASE,
].join(JOIN_OPERATOR);

export const WORKSPACE_FIELD = [
  SampleAssetTopology.SAMPLE,
  SampleTopology.CASE,
  CaseTopology.WORKSPACE,
].join(JOIN_OPERATOR);

export const DEVICE_TYPE_FIELD = [
  AnalysisTopology.ASSET,
  AssetTopology.DEVICE,
  DeviceTopology.TYPE,
].join(JOIN_OPERATOR);

export const ACQUIRED_BY_FIELD = [
  AnalysisTopology.ASSET,
  AssetTopology.CREATED_BY,
].join(JOIN_OPERATOR);

export const METHOD_TYPE_FIELD = [
  AnalysisTopology.ASSET,
  AssetTopology.METHOD_TYPE,
  MethodTypeTopology.ANALYSIS_TYPES,
].join(JOIN_OPERATOR);

export const assetFields = [
  DEVICE_TYPE_FIELD,
  ACQUIRED_BY_FIELD,
  METHOD_TYPE_FIELD,
];

export const analysisFields: string[] = [
  AnalysisTopology.CREATED_BY,
  CASE_FIELD
];

export const FINDING_SAMPLE_FILED = [FindingTopology.ANALYSIS, AnalysisTopology.SAMPLE].join(JOIN_OPERATOR);
export const FINDING_CASE_FIELD = [FindingTopology.ANALYSIS, CASE_FIELD].join(JOIN_OPERATOR);
export const FINDING_WORKSPACE_FIELD = [FindingTopology.ANALYSIS, WORKSPACE_FIELD].join(JOIN_OPERATOR);
